import React from 'react';
import { useStacklineTheme } from '@stackline/ui';
import { NoDataIcon } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { Typography } from '@mui/material';
import { NoneFoundIcon } from 'src/components/SvgIcons';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SxProps } from '@mui/system';
import colors from 'src/utils/colors';

export interface SlMessagingPlaceholderProps {
  title: string;
  subtitle: string | React.ReactNode;
  maxWidth?: number;
  renderIcon?: () => React.ReactNode;
  icon?: React.ReactNode;
  sx?: SxProps;
}

/**
 Placeholder for missing data
 */
const SlPlaceholderMessage = ({ title, subtitle, maxWidth = 244, renderIcon, sx }: SlMessagingPlaceholderProps) => {
  const theme = useStacklineTheme();

  return (
    <Flex gap="md" flexDirection="column" alignItems="start" sx={sx}>
      {renderIcon && renderIcon()}
      {!renderIcon && (
        <NoDataIcon
          icon={<NoneFoundIcon />}
          iconBackgroundStyle={{
            backgroundColor: theme.colors.secondaryGhost
          }}
        />
      )}
      <Flex flexDirection="column" gap={8} alignItems="start">
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: colors.darkBlue
          }}
          variant="subtitle1"
        >
          {title}
        </Typography>
        <div style={{ maxWidth: `${maxWidth}px` }}>
          <Text variant="body1" lineHeight="24px">
            {subtitle}
          </Text>
        </div>
      </Flex>
    </Flex>
  );
};

export default SlPlaceholderMessage;
